import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/walletconnect.svg")